import createAction from 'flux-actions/createAction';
import keyMirror from 'react-utils/keyMirror';
import { mapPayloadTo } from '../utils';
export const SecurityPhoneNumberActionTypes = keyMirror({
  FETCH_CONFIGURATION: null,
  FETCH_CONFIGURATION_SUCCESSFUL: null,
  FETCH_CONFIGURATION_FAILED: null,
  SKIP_SETUP: null,
  CLICKED_SETUP: null,
  COMPLETED_SETUP: null,
  CANCELLED_SETUP: null,
  CONFIRMED_SETUP: null,
  CONFIGURE_SMS: null,
  CONFIGURE_SMS_REQUEST: null,
  CONFIGURE_SMS_SUCCESS: null,
  CONFIGURE_SMS_FAILURE: null,
  RESEND_CODE: null,
  RESEND_CODE_FAILURE: null,
  CODE_ATTEMPT: null,
  CODE_ATTEMPT_REQUEST: null,
  CODE_ATTEMPT_SUCCESS: null,
  CODE_ATTEMPT_FAILURE: null,
  CHANGED_CODE_ATTEMPT: null,
  CHANGE_SECURITY_NUMBER: null,
  DELETE_SECURITY_NUMBER: null,
  DELETE_SECURITY_NUMBER_REQUEST: null,
  DELETE_SECURITY_NUMBER_SUCCESS: null,
  DELETE_SECURITY_NUMBER_FAILURE: null,
  CLICKED_VERIFY: null
});
export const fetchConfiguration = createAction(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION);
export const fetchConfigurationSuccessful = createAction(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_SUCCESSFUL, mapPayloadTo('securityPhoneNumber'));
export const fetchConfigurationFailed = createAction(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_FAILED);
export const skipSetup = createAction(SecurityPhoneNumberActionTypes.SKIP_SETUP);
export const setup = createAction(SecurityPhoneNumberActionTypes.CLICKED_SETUP, mapPayloadTo('numberExist'));
export const resendCode = createAction(SecurityPhoneNumberActionTypes.RESEND_CODE, mapPayloadTo('securityPhoneNumber'));
export const completeSetup = createAction(SecurityPhoneNumberActionTypes.COMPLETED_SETUP);
export const cancelSetup = createAction(SecurityPhoneNumberActionTypes.CANCELLED_SETUP);
export const confirmSetup = createAction(SecurityPhoneNumberActionTypes.CONFIRMED_SETUP);
export const configureSms = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS, mapPayloadTo('phoneNumber'));
export const configureSmsRequest = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS_REQUEST, mapPayloadTo('phoneNumber'));
export const configureSmsSuccess = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS_SUCCESS, mapPayloadTo('securityPhoneNumber'));
export const configureSmsFailure = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS_FAILURE, mapPayloadTo('error'));
export const resendCodeFailure = createAction(SecurityPhoneNumberActionTypes.RESEND_CODE_FAILURE, mapPayloadTo('error'));
export const changeCodeAttempt = createAction(SecurityPhoneNumberActionTypes.CHANGED_CODE_ATTEMPT, mapPayloadTo('codeAttempt'));
export const codeAttempt = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT, mapPayloadTo('securityPhoneNumber', 'codeAttempt'));
export const codeAttemptRequest = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_REQUEST);
export const codeAttemptSuccess = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_SUCCESS, mapPayloadTo('securityPhoneNumber'));
export const codeAttemptFailure = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_FAILURE, mapPayloadTo('error'));
export const changeSecurityNumber = createAction(SecurityPhoneNumberActionTypes.CHANGE_SECURITY_NUMBER, mapPayloadTo('phoneNumber'));
export const deleteTrustedPhoneNumber = createAction(SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER);
export const deleteNumberSuccess = createAction(SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_SUCCESS);
export const deleteNumberRequest = createAction(SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_REQUEST);
export const deleteNumberFailure = createAction(SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_FAILURE, mapPayloadTo('error'));